export const GET_ACTIVITIES = "GET_ACTIVITIES";
export const GET_ACTIVITY_BY_ID = "GET_ACTIVITY_BY_ID";
export const UPDATE_ACTIVITY = "UPDATE_ACTIVITY";
export const DELETE_ACTIVITY = "DELETE_ACTIVITY";
export const CREATE_ACTIVITY = "CREATE_ACTIVITY";
